<template>
<div class="chapter">
<div class="inner_page">
<div id="Part-I.html" xml:lang="en-US">
<div class="PL-Title-Page-Dividing-Line-4">
<p class="ch-part"><a id="Anchor-1">Part I</a></p><a id="Anchor-1">
<p class="pl-header-part">Ambition, Art, Passion</p>
<p class="epigraph">We knew very well that we were damned,</p>
<p class="epigraph">But hope of love along the way</p>
<p class="epigraph">Made both of us think</p>
<p class="epigraph">Of what the Gypsy did prophesy.</p>
<p class="citation">—Guillaume Apollinaire</p>
</a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PartI.vue?d46f46a6